"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultDataFactory = require("@rdfjs/data-model");

var SparqlXmlBindingsTransformer_1 = require("./SparqlXmlBindingsTransformer"); // tslint:disable-next-line:no-var-requires


var XmlNode = require('sax-stream');
/**
 * Parser for the SPARQL Query Results XML format.
 * @see https://www.w3.org/TR/rdf-sparql-XMLres/
 */


var SparqlXmlParser =
/*#__PURE__*/
function () {
  function SparqlXmlParser(settings) {
    _classCallCheck(this, SparqlXmlParser);

    settings = settings || {};
    this.dataFactory = settings.dataFactory || DefaultDataFactory;
    this.prefixVariableQuestionMark = !!settings.prefixVariableQuestionMark;
  }
  /**
   * Convert a SPARQL XML bindings response stream to a stream of bindings objects.
   *
   * The bindings stream will emit a 'variables' event that will contain
   * the array of variables (as RDF.Variable[]), as defined in the response head.
   *
   * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL XML response stream.
   * @return {NodeJS.ReadableStream} A stream of bindings.
   */


  _createClass(SparqlXmlParser, [{
    key: "parseXmlResultsStream",
    value: function parseXmlResultsStream(sparqlResponseStream) {
      var _this = this;

      // Collect variables
      var variables = [];
      sparqlResponseStream.pipe(XmlNode({
        strict: true,
        tag: 'variable'
      })).on('data', function (node) {
        return variables.push(_this.dataFactory.variable(node.attribs.name));
      }).on('error', function () {
        return;
      }) // Ignore errors, they will emitted in the results
      .on('finish', function () {
        return resultStream.emit('variables', variables);
      }); // Collect results

      var resultStream = sparqlResponseStream.pipe(XmlNode({
        strict: true,
        tag: 'result'
      })).on('error', function (error) {
        return resultStream.emit('error', error);
      }).pipe(new SparqlXmlBindingsTransformer_1.SparqlXmlBindingsTransformer(this)); // Propagate errors

      sparqlResponseStream.on('error', function (error) {
        return resultStream.emit('error', error);
      });
      return resultStream;
    }
    /**
     * Convert a SPARQL XML result binding to a bindings object.
     * @param rawBindings A SPARQL XML result binding.
     * @return {IBindings} A bindings object.
     */

  }, {
    key: "parseXmlBindings",
    value: function parseXmlBindings(rawBindings) {
      var bindings = {};

      if (rawBindings.children) {
        var bindingsArray = Array.isArray(rawBindings.children.binding) ? rawBindings.children.binding : [rawBindings.children.binding];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = bindingsArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var binding = _step.value;

            if (binding.attribs && binding.children) {
              var key = binding.attribs.name;
              var term = null;

              if (binding.children.bnode) {
                term = this.dataFactory.blankNode(binding.children.bnode.value);
              } else if (binding.children.literal) {
                var value = binding.children.literal.value || "";
                var attribs = binding.children.literal.attribs;

                if (attribs && attribs['xml:lang']) {
                  term = this.dataFactory.literal(value, attribs['xml:lang']);
                } else if (attribs && attribs.datatype) {
                  term = this.dataFactory.literal(value, this.dataFactory.namedNode(attribs.datatype));
                } else {
                  term = this.dataFactory.literal(value);
                }
              } else {
                term = this.dataFactory.namedNode(binding.children.uri.value);
              }

              bindings[this.prefixVariableQuestionMark ? '?' + key : key] = term;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return bindings;
    }
    /**
     * Convert a SPARQL XML boolean response stream to a promise resolving to a boolean.
     * This will reject if the given response was not a valid boolean response.
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL XML response stream.
     * @return {NodeJS.ReadableStream} A stream of bindings.
     */

  }, {
    key: "parseXmlBooleanStream",
    value: function parseXmlBooleanStream(sparqlResponseStream) {
      return new Promise(function (resolve, reject) {
        sparqlResponseStream.on('error', reject);
        sparqlResponseStream.pipe(XmlNode({
          strict: true,
          tag: 'boolean'
        })).on('error', reject).on('data', function (node) {
          return resolve(node.value === 'true');
        }).on('end', function () {
          return reject(new Error('No valid ASK response was found.'));
        });
      });
    }
  }]);

  return SparqlXmlParser;
}();

exports.SparqlXmlParser = SparqlXmlParser;